import { type User } from 'firebase/auth';
import { createContext } from 'react';

export interface AuthContextType {
  currentUser: User | null;
  loading: boolean;
  signInWithSAML: () => Promise<void>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
